/* eslint-disable arrow-parens */
// Small reusable editor for a string[] field (title_lines, subtitle_lines,
// text_block.lines, a columns entry's lines, eligible_plan_names, ...) — one
// text field per line, each with its own remove button, plus an "Add line"
// button. Used across most section field editors below instead of
// duplicating this add/remove/update logic per section type.
import { Button, IconButton, TextField } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";

interface StringListEditorProps {
	label: string;
	values: string[];
	onChange: (next: string[]) => void;
	placeholder?: string;
}

const StringListEditor = ({ label, values, onChange, placeholder }: StringListEditorProps) => {
	const handleLineChange = (index: number, value: string) => {
		const next = [...values];
		next[index] = value;
		onChange(next);
	};

	const handleRemove = (index: number) => {
		onChange(values.filter((_, i) => i !== index));
	};

	const handleAdd = () => {
		onChange([...values, ""]);
	};

	return (
		<div style={{ marginBottom: 8 }}>
			{values.map((value, index) => (
				// eslint-disable-next-line react/no-array-index-key
				<div key={index} style={{ display: "flex", alignItems: "center", gap: 4, marginBottom: 4 }}>
					<TextField
						label={values.length > 1 ? `${label} ${index + 1}` : label}
						value={value}
						onChange={(event) => handleLineChange(index, event.target.value)}
						placeholder={placeholder}
						fullWidth
						variant="outlined"
						margin="dense"
					/>
					<IconButton size="small" onClick={() => handleRemove(index)} aria-label={`Remove ${label}`}>
						<DeleteIcon fontSize="small" />
					</IconButton>
				</div>
			))}
			<Button size="small" startIcon={<AddIcon fontSize="small" />} onClick={handleAdd}>
				Add {label}
			</Button>
		</div>
	);
};

export default StringListEditor;
